import React, { useEffect, useState } from 'react'

import { SubtypesSelect } from '@app/components'
import { RendererWrapper } from '@app/components/renderers'

import { cloneDeep } from '@app/utils'
import { getSelectedValues } from '@app/utils/filters'
import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { SIZE } from '@app/constants'
import { MONITORING_PRODUCT_STATUS } from '@app/api/constants'

import type { Column } from '@app/components/base/Table/types'
import type { RegistryCurrentListDataSource } from '@app/pages/RegistryPageInner/types'
import type { UseSubtypesColumnParams } from './types'

export const useSubtypesColumn = ({
  monitoringList,
  columns: rawColumns,
  patchFn
}: UseSubtypesColumnParams): Array<Column<RegistryCurrentListDataSource>> => {
  const [columnsWithSubtypes, setColumnsWithSubtypes] = useState(rawColumns)

  useEffect(() => {
    const columns = cloneDeep(rawColumns)
    const subtypesColumn = columns.find(column => column.key === 'subtypes')
    const monitoringSubtypes = monitoringList?.monitoringType.monitoringSubtypes

    if (subtypesColumn) {
      subtypesColumn.render = (_, { subtypes, id: productId, status }) => {
        const options = getFilterFromEntities(monitoringSubtypes)
        const defaultValue = getFilterFromEntities(subtypes)

        const handlePatch = (monitoringSubtypeIds: string[]): void => {
          patchFn({
            productId,
            monitoringSubtypeIds
          })
        }

        return (
          <RendererWrapper
            minWidth={ 200 }
            maxWidth={ 250 }
          >
            <SubtypesSelect
              size={ SIZE.small }
              loading={ !monitoringSubtypes }
              disabled={ !monitoringSubtypes || status === MONITORING_PRODUCT_STATUS.DELETED }
              options={ options }
              defaultValue={ defaultValue }
              onClear={ () => handlePatch([]) }
              onAccept={ selectedOptions => handlePatch(getSelectedValues(selectedOptions)) }
            />
          </RendererWrapper>
        )
      }

      setColumnsWithSubtypes(columns)
    }
  }, [monitoringList, rawColumns, patchFn])

  return columnsWithSubtypes
}
